import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';
import Tooltip from '../../../../../components/Tooltip';

const fakeToken = '************************';

const EditBot = ({ error, open, type, isLoading, isLoadingSubmit, onSubmit, onHide }) => {
  const formNode = useRef(null);
  const authTokenNode = useRef(null);
  const [data, setData] = useState({
    disabledAuthToken: true,
    bot_token: fakeToken,
  });

  const { disabledAuthToken, bot_token } = data;

  const onInitChangeAuthToken = (e) => {
    e.preventDefault();
    setData((prevState) => ({
      ...prevState,
      disabledAuthToken: false,
      bot_token: '',
    }))
  }

  const onChangeForm = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  useEffect(() => {
    if (!disabledAuthToken) {
      authTokenNode?.current?.focus()
    }
  }, [disabledAuthToken]);

  useEffect(() => {
    if (!open) {
      setData((prevState) => ({
        ...prevState,
        disabledAuthToken: true,
        bot_token: fakeToken,
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const onSubmitForm = (event) => {
    event?.preventDefault();
    if (!disabledAuthToken) {
      onSubmit?.(type, {
        bot_token,
      });
    }
  };

  return (
    <Modal show={open} onHide={!isLoadingSubmit ? onHide : undefined} backdrop="static">
      <form ref={formNode} onSubmit={onSubmitForm}>
        <Modal.Header closeButton>
          <Modal.Title>Telegram bot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading || isLoadingSubmit ? <div className="modal-loader-small" /> : null}
          {error && <Alert text={error} />}
          <div>
            <FormGroup>
              <ControlLabel htmlFor="bot_token">Authentication token</ControlLabel>
              <Tooltip
                placement="top"
                text={disabledAuthToken ? <span>The key is hidden for security reasons</span> : undefined}
                tooltipClass="tooltip__top"
              >
                <FormControl
                  autoComplete="off"
                  value={bot_token}
                  onChange={(e) => onChangeForm('bot_token', e.target.value)}
                  inputRef={(input) => authTokenNode.current = input}
                  disabled={disabledAuthToken}
                  type={disabledAuthToken ? 'password' : 'text'}
                  name="bot_token"
                  id="bot_token"
                />
              </Tooltip>
              {disabledAuthToken
                ? (
                  <div className="help-block">
                    <a href=" #" onClick={onInitChangeAuthToken}>
                      Change token
                    </a>
                  </div>
                ) : null }
            </FormGroup>
          </div>
        </Modal.Body>
        <Modal.Footer className="custom__modal-footer">
          <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading || disabledAuthToken} onClick={onSubmitForm}>
            {isLoadingSubmit && <Spinner />}
            <span>Save changes</span>
          </Button>
          <Button
            disabled={isLoadingSubmit || isLoading}
            onClick={() => {
              onHide();
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

EditBot.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default EditBot;
